module.exports = __webpack_public_path__ + "static/media/posSmall.04640689.png";